export default __webpack_public_path__ + "static/media/ORCID-Badge-v-03-CONNECT.4a0f0f4b.svg";